import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { NavMarker } from 'react-rhumb';
import { useErrorBanner } from '../../../hooks/useErrorBanner';

// When an error state is decoupled from the catch-all hasPricingAndPurchasingFailed selector
// We can pull in the individual fail state here and surface specific language to users
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FallbackErrorBanner = () => {
  const errorBanner = useErrorBanner();
  if (errorBanner) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "FALLBACK_ERROR_BANNER"
      }), /*#__PURE__*/_jsx(Alert, {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: errorBanner.title
        }),
        type: "danger",
        marginBlockEnd: "400",
        inlineSize: "100%",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: errorBanner.description
        })
      })]
    });
  }
  return null;
};
export default FallbackErrorBanner;